import { render } from "./IconClinics.vue?vue&type=template&id=1e51c4f6"
import script from "./IconClinics.vue?vue&type=script&lang=js"
export * from "./IconClinics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__